import { all } from 'redux-saga/effects';
import watchAuthSaga from '../containers/AuthWrapper/saga.js';
// User Saga
import watchPatient from '../containers/Layouts/User/Home/saga';
import watchProfileSaga from '../containers/Layouts/User/Profile/saga';
import watchCaseDetails from '../containers/Layouts/User/CaseDetails/saga';
// Admin Saga
import watchDentists from '../containers/Layouts/Admin/Dentists/saga';
import watchAdminCases from '../containers/Layouts/Admin/AllCases/saga';
import watchAdminPatients from '../containers/Layouts/Admin/Patients/saga';
import watchAdminDashboard from '../containers/Layouts/Admin/dashboard/saga';
import watchAdminAvailableUnits from '../containers/Layouts/Admin/AvailableUnits/saga';
import watchAdminCaseDetails from '../containers/Layouts/Admin/AdminCaseDetails/saga';
import watchDailyReports from '../containers/Layouts/Admin/DailyReport/saga';
import watchAdminPatientDetails from '../containers/Layouts/Admin/PatientDetails/saga';
import watchAdminDentistDetails from '../containers/Layouts/Admin/DentistDetails/saga';
// Default Saga
import watchHistory from "../containers/History/saga";
import watchLoginUserSaga from '../containers/Layouts/Default/Signin/saga';
import watchRegisterSaga from '../containers/Layouts/Default/Register/saga';
import watchVerifyUserSaga from '../containers/Layouts/Default/VerifyUser/saga';
import watchResetPasswordSaga from '../containers/Layouts/Default/ResetPassword/saga';
import watchForgetPasswordUserSaga from '../containers/Layouts/Default/ForgetPassword/saga';
import watchChatSaga from '../containers/Chat/saga';
// Shared
import watchImageUploadSaga from "../shared/redux/saga/imageUploadSaga";

export default function* () {
    yield all([
        watchRegisterSaga(),
        watchVerifyUserSaga(),
        watchLoginUserSaga(),
        watchAuthSaga(),
        watchForgetPasswordUserSaga(),
        watchResetPasswordSaga(),
        watchDentists(),
        watchPatient(),
        watchProfileSaga(),
        watchCaseDetails(),
        watchAdminPatients(),
        watchAdminDashboard(),
        watchAdminCases(),
        watchAdminCaseDetails(),
        watchAdminAvailableUnits(),
        watchDailyReports(),
        watchAdminPatientDetails(),
        watchAdminDentistDetails(),
        watchChatSaga(),
        watchHistory(),
        watchImageUploadSaga()
    ]);
}



// WEBPACK FOOTER //
// ./src/utils/rootSaga.js